import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from '../services/baseQuery';
import { GlobalType } from '../types';

const globalApi = createApi({
  reducerPath: GlobalType.EP_SLICE_NAME,
  baseQuery: axiosBaseQuery({}),
  endpoints: () => ({}),
});

// Extend API with additional endpoints
export const globalApiEndpoints = globalApi.injectEndpoints({
  endpoints: () => ({}),
});

export default globalApi;
